import {useEffect, useState} from "react";
import {
    CheckIcon,
    ThinAddIcon,
    ThinEditIcon,
    ThinNotAllowedIcon,
    ThinTrashIcon
} from "../../../components/icons/material-icons";
import {BreadCrumbs} from "../../../components/open/pages";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AdminsStaffHireAddEditJobModal} from "./hire-add-job-modal";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {Link} from "react-router-dom";

interface careersJobsInterface {
    id: number,
    title: string,
    needed: number,
    signup: number,
    unseen: number,
    taken: boolean,
}

export const AdminsStaffHireScreen = () => {
    const [list, setList] = useState<careersJobsInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/careers/jobs/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: careersJobsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "فرصت‌های شغلی | منابع انسانی | اتوماسیون";
        fetchList();
    }, []);
    const [addEditModal, setAddEditModal] = useState({
        show: false,
        edit: false,
        id: 0,
    });
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/hire', title: 'فرصت‌های شغلی'},
            ]}/>
            {
                loaded ? <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                    <div className="screen-card">
                        <div className="screen-card-header">
                            <b>فرصت‌های شغلی</b>
                            <div className="d-flex align-items-center" style={{gap: 5}}>
                                <button onClick={() => setAddEditModal({
                                    show: true,
                                    edit: false,
                                    id: 0,
                                })}>
                                    <ThinAddIcon/>
                                    <span>فرصت جدید</span>
                                </button>
                            </div>
                        </div>
                        <table className="table open-table table-stripped table-hover table-bordered">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>عنوان</th>
                                <th>وضعیت</th>
                                <th>مورد نیاز</th>
                                <th>تعداد کل ثبت‌نام</th>
                                <th>بررسی نشده</th>
                                <th>امکانات</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                list.map((d, i) =>
                                    <tr key={"J3XxDK2S_A" + i}>
                                        <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                        <td><Link to={"/admins/staff/hire/view/" + d.id}>{d.title}</Link></td>
                                        <td>
                                            {
                                                !d.taken ?
                                                    <em data-color="blue"><CheckIcon/>فعال</em> :
                                                    <em data-color="red"><ThinNotAllowedIcon/>پایان یافته</em>
                                            }
                                        </td>
                                        <td>{CurrencyFormat(d.needed)}</td>
                                        <td>{CurrencyFormat(d.signup)}</td>
                                        <td>{CurrencyFormat(d.unseen)}</td>
                                        <td>
                                            <div className="d-inline-flex align-items-center" style={{gap: 5}}>
                                                <button className="open-tooltip" onClick={() => setAddEditModal({
                                                    show: true,
                                                    edit: true,
                                                    id: d.id,
                                                })}>
                                                    <ThinEditIcon/>
                                                    <i>ویرایش</i>
                                                </button>
                                                <button className="open-tooltip" onClick={() => setRemoveModal({
                                                    show: true,
                                                    id: d.id,
                                                    title: d.title,
                                                })}>
                                                    <ThinTrashIcon/>
                                                    <i>حذف</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                </div> : null
            }
            <AdminsStaffHireAddEditJobModal
                active={addEditModal.show}
                closeHandler={() => setAddEditModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                id={addEditModal.id.toString()}
                edit={addEditModal.edit}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف فرصت‌شغلی"}
                desc={`آیا مطمئن هستید که می‌خواهید فرصت شغلی ${removeModal.title} را حذف کنید؟`}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/careers/jobs/remove',
                        {
                            job: removeModal.id.toString(),
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            fetchList();
                            ShowSnackbar(
                                'فرصت شغلی حذف گردید.',
                                'باشه',
                                5000,
                            );
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};